import {number, route, string} from 'react-router-typesafe-routes/dom';
import {zod} from 'react-router-typesafe-routes/zod';
import {JobTypes, JobTypesSchema} from '../api/generated/enums.ts';

// Common
const INDEX = route('');
const CREATE = route('create', {});
const DETAIL = route(':id', {params: {id: number().default(0)}});

export type DetailRoute = {
  buildPath: (props: {id: number}) => string;
};

const DEFAULT_CRUD = {INDEX, CREATE, DETAIL};

// Routes
const LOGS = route(
  'logs',
  {},
  {
    GROUPED_DETAIL: route(':parameters', {
      params: {parameters: string().default('')},
    }),
    ERROR_DETAIL: route(':id', {
      params: {id: number().default(0)},
    }),
    INDEX,
  },
);

const FIELDS = route('fields', {}, DEFAULT_CRUD);
const CODES = route('codes', {}, DEFAULT_CRUD);
const ACTION_CODES = route('action-codes', {}, DEFAULT_CRUD);
const ACTION_CLASSES = route('action-classes', {}, DEFAULT_CRUD);
const REVIEWS = route('reviews', {}, {INBOX: route('inbox')});
const JOB_REVIEWS = route(
  'jobs/:jobId/reviews',
  {
    params: {jobId: number().default(0)},
  },
  {...DEFAULT_CRUD, RESPONSE: route('response')},
);
const JOBS = route(
  'jobs',
  {},
  {
    INDEX,
    DETAIL,
    CREATE: route('create/:jobType', {
      params: {jobType: zod(JobTypesSchema).default(JobTypes["M&M"])},
    }),
  },
);
const REPAIR_DOCUMENTS = route('repair-documents', {}, DEFAULT_CRUD);
const EMAIL_EVALUATIONS = route('email-evaluations', {}, DEFAULT_CRUD);
const PARTNER_SITES = route('partner-sites', {}, DEFAULT_CRUD);
const ROUTE_PATTERNS = route('route-patterns', {}, DEFAULT_CRUD);
const EMAIL_LOG = route('email-log', {}, {INDEX, DETAIL});
const SETTINGS = route('settings', {}, {INDEX, DETAIL});
const USERS = route('users', {}, DEFAULT_CRUD);

export const ROUTES = {
  DASHBOARD: route(''),
  CALLBACK: route('callback', {}),
  ADMIN: route(
    'admin',
    {},
    {
      LOGS,
      PARTNER_SITES,
      FIELDS,
      CODES,
      ACTION_CODES,
      ACTION_CLASSES,
      REVIEWS,
      JOB_REVIEWS,
      JOBS,
      REPAIR_DOCUMENTS,
      EMAIL_EVALUATIONS,
      ROUTE_PATTERNS,
      EMAIL_LOG,
      SETTINGS,
      USERS,
    },
  ),
  DEMO: route('demo'),
};